import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { GeneralComponent } from '../../General/g.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import {GeneralExerciseComponent } from '../../General/g-exercise.component';
import { TopicService } from '../topic.service';

@Component({
  selector: 'app-open-question',
  templateUrl: './open-question.component.html',
  styleUrls: ['./open-question.component.css']
})
export class OpenQuestionComponent extends GeneralExerciseComponent{

  public solution = "";
  public question: string;
  showRepresentation: boolean = true;
  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
  }

  setTypeSpecificsFromConfiguration(){
    if(this.configuration.typespecifics.question != undefined){
      this.question = this.configuration.typespecifics.question;
      this.showRepresentation = this.configuration.typespecifics.showRepresentation;
    }
    this.solution = "";
  }

  setTypeSpecificsFromState(){
    if(this.state.typespecific.solution != undefined){
      this.solution = this.state.typespecific.solution;
  }
  }

  computeState(){
    this.state.typespecific.solution = this.solution;
  }

  /** checks, whether the solution is correct and sends messages */
  checkSolution(){
    let solutionArray:any[] = this.solution.split(",");
    solutionArray = solutionArray.map(v => +v);
    solutionArray = solutionArray.filter(v => !Number.isNaN(+v) && v!=undefined && v!= "");
    solutionArray = solutionArray.sort((a,b)=> +a -+b);
    this.solution = solutionArray.toString();
    if(this.question != undefined && this.question != ""){
      if (this.expectedSolution() == this.solution){
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 3000);
        this.solved = true;
          this.state.solved = true;
        this.saveState();
      } else {
        this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
      }
    } else {
      if(this.solution.length > 0){
        this.solved = true;
        this.state.solved = true;
        this.saveState();
      }
    }
  }

/** evaluates the current state of the exercise 
   * @returns {number} - returns the total number of points 
  */
 evaluate(): number[] {
  let result = 1;
  if(this.question != ""){
    result = +(this.expectedSolution() == this.solution);
  }
  return [result,1];
}

/** returns the expected solution based on the typespecific parts of the question */
expectedSolution():any{
  return null;
}

}
